import { DEFAULT_DOMAIN, DEFAULT_BASE_DOMAIN, DOMAIN_PATTERNS, } from "../constants/domainConstants";
/**
 * Extracts the base domain from API_URL
 * Examples:
 * - "https://api-dev.service.maatai.com/api/v4" -> "https://dev.maatai.com"
 * - "https://api-sandbox.service.maatai.com/api/v4" -> "https://sandbox.maatai.com"
 * - "https://provident.maatai.com/api/v4" -> "https://provident.maatai.com"
 *
 * @param apiUrl - The API URL from environment variables
 * @returns The base domain URL (e.g., "https://dev.maatai.com")
 */
export function getBaseDomainFromApiUrl(apiUrl) {
    if (!apiUrl) {
        return DEFAULT_BASE_DOMAIN;
    }
    try {
        var url = new URL(apiUrl);
        var hostname = url.hostname;
        // Extract subdomain before "service.maatai.com" or "maatai.com"
        var domain = DEFAULT_DOMAIN;
        if (hostname.includes("service.maatai.com")) {
            // Format: api-{env}.service.maatai.com
            var match = hostname.match(DOMAIN_PATTERNS.SERVICE_PATTERN);
            if (match) {
                domain = match[1];
            }
        }
        else if (hostname.includes("maatai.com")) {
            // Format: {env}.maatai.com or provident.maatai.com
            var match = hostname.match(DOMAIN_PATTERNS.DIRECT_PATTERN);
            if (match) {
                domain = match[1];
            }
        }
        return "https://".concat(domain, ".maatai.com");
    }
    catch (error) {
        console.warn("Error parsing API_URL, using default domain:", error);
        return DEFAULT_BASE_DOMAIN;
    }
}
